import EditorBtn from './EditorBtn'

export default EditorBtn


// WEBPACK FOOTER //
// ./src/board/EditorBtn/index.js